import { Injectable, Type } from '@angular/core';

@Injectable()
export class ActionService {
    /**
     * The list of registered actions.
     */
    protected actions: { [key: string]: { component: Type<any>, data: { [key: string]: any } } } = {};

    /**
     * Register a new action.
     *
     * @param name - The action name.
     * @param component - The action component to render.
     * @param data
     */
    public register(name: string, component: Type<any>, data?: { [key: string]: any }): this {
        const actions = Object.assign({}, this.actions);
        actions[name] = {
            component: component,
            data: data ? data : {}
        };
        this.actions  = actions;

        return this;
    }

    /**
     * Get a action.
     *
     * @param name - The action name.
     */
    public get(name: string): { component: Type<any>, data: { [key: string]: any } } | null {
        return this.actions[name]
            || null;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/services/action.service.ts